import { DeviceBreakpointsTypeUtils } from '../../../types/breakpoints/breakpoints';
export const isActive = (state, currentActivePoint, checkActivePoint) => {
    return state && currentActivePoint === checkActivePoint;
};
// Do not show tooltip on grabbing if desktops
export const isTooltipVisible = (tooltip, pressed, device) => {
    return !!tooltip && (!DeviceBreakpointsTypeUtils.isDesktop(device) || !pressed);
};
//# sourceMappingURL=ui.utils.js.map